import { BlockQuote } from './Blockquote';
import { Code } from './Code';
import { OrderedList, UnorderedList } from './List';
import { NextLink } from './NextLink';
import { Table } from './Table';

interface MarkdownComponentsMap {
  a: typeof NextLink;
  ul: typeof UnorderedList;
  ol: typeof OrderedList;
  table: typeof Table;
  blockquote: typeof BlockQuote;
  code: typeof Code;
}

export const markdownComponents: MarkdownComponentsMap = {
  a: NextLink,
  ul: UnorderedList,
  ol: OrderedList,
  table: Table,
  blockquote: BlockQuote,
  code: Code,
};
